// laravel passport

import { PbxHttpClient } from "@/services/httpclient";

const state = {
  users: [],
  notifications: [],
  isOpenSmsDialog: false,
};

const getters = {
  GET_NOTIFY: (state) => {
    return state.notifications;
  },

  GET_ISOPENSMSDIALOG: (state) => state.isOpenSmsDialog,
};

const mutations = {
  SET_SMS_DIALOG_STATE(state, isOpen) {
    state.isOpenSmsDialog = isOpen;
  },

  PUSH_USER: (state, payload) => {
    const value = state.users.find((element) => {
      return element.id === payload.id;
    });
    if (value === undefined) {
      state.users.push(payload);
    }
  },

  SET_NOTIFY: (state, payload) => {
    state.notifications = payload;
  },

  UPDATE_USER: (state, payload) => {
    const indexupdate = state.users
      .map((element) => {
        return element.id;
      })
      .indexOf(payload.id);
    if (indexupdate > -1) {
      state.users.splice(indexupdate, 1, payload);
    }
  },

  DELETE_USER: (state, payload) => {
    const indexdelete = state.users
      .map((element) => {
        return element.id;
      })
      .indexOf(payload);
    if (indexdelete > -1) {
      state.users.splice(indexdelete, 1);
    }
  },

  REPLACE_USERS: (state, payload) => {
    state.users = payload;
  },
  SET_USERS: (state, payload) => (state.users = state.users.concat(payload)),
};

const actions = {
  async GET_USERS({ state, commit }, options) {
    commit("REPLACE_USERS", []);
    try {
      const res = await PbxHttpClient.get(`/users`, options);

      //Compare if response items already exists in store
      const userStr = JSON.stringify(state.users);
      const resStr = JSON.stringify(res.data.data);
      if (!userStr.includes(resStr.substring(1, resStr.length - 1))) commit("SET_USERS", res.data.data);
      return res.data;
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async GET_USER(_data, payload) {
    // console.log("OBTENIENDO USUARIOS");
    try {
      const res = await PbxHttpClient.get(`/users/${payload}`);
      return res.data;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  /**
   * [GET_PASSWORD description]
   * @param {[type]} options.state  [description]
   * @param {[type]} options.commit [description]
   * @param {[type]} payload        [description]
   * @returns {string}
   */
  async GET_NOTIFY({ commit }) {
    try {
      const { data } = await PbxHttpClient.get("/admin/quantity_details");
      commit("SET_NOTIFY", data);
      return data;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  async GET_PASSWORD(_data, payload) {
    try {
      const res = await PbxHttpClient.post(`/password/${payload}`);
      return res.data;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  async CREATE_USER({ commit }, payload) {
    try {
      const res = await PbxHttpClient.post(`/users/`, payload);
      commit("PUSH_USER", res.data);
      return res; // 👈 IMPORTANTE
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async UPDATE_USER({ commit }, payload) {
    try {
      const res = await PbxHttpClient.put(`/users/${payload.id}`, payload);
      commit("UPDATE_USER", res.data);
      return;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  async UPDATE_USERPHOTOPROFILE(_data, payload) {
    try {
      const response = await PbxHttpClient.post(`/profile/updateImage`, payload);
      // commit("UPDATE_AVATAR", res.data.url_image);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_USER({ commit }, payload) {
    try {
      await PbxHttpClient.delete(`/users/${payload}`);
      commit("DELETE_USER", payload);
      return;
    } catch (error) {
      // console.log(error);
      return Promise.reject();
    }
  },

  async CHANGE_STATUS({ commit }, payload) {
    try {
      const res = await PbxHttpClient.get(`/user_status/${payload.id}`);
      commit("UPDATE_USER", res.data[0]);
      return;
    } catch (error) {
      return Promise.reject();
    }
  },

  async CHANGE_ON_LEAVE(_data, payload) {
    try {
      await PbxHttpClient.put(`/user_on_leave/${payload.id}`);
      return;
    } catch (error) {
      return Promise.reject();
    }
  },

  async QUIT_PAUSE(_data, payload) {
    try {
      await PbxHttpClient.put(`/agent/use_pause/${payload.id}`);
      // commit("UPDATE_USER", res.data[0]);
      return;
    } catch (error) {
      return Promise.reject();
    }
  },

  OPENSMSDIALOG({ commit }) {
    commit("SET_SMS_DIALOG_STATE", true);
  },

  CLOSESMSDIALOG({ commit }) {
    commit("SET_SMS_DIALOG_STATE", false);
  },
};

// exportar propiedades
export const user = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
